import { CancelBookingNotesModalComponent } from "./../../../shared/components/cancel-booking-notes-modal/cancel-booking-notes-modal.component";
import {
  Component,
  OnInit,
  Output,
  EventEmitter,
  Input,
  TemplateRef,
  OnDestroy,
  ViewChild,
} from "@angular/core";
import { NavigationService } from "../../../providers/navigation.service";
import { Router, ActivatedRoute } from "@angular/router";
import { ITableColumnHeader } from "../../../models/table-column-header";
import { Subscription } from "rxjs";
import { ApiService } from "../../../providers/api.service";
import { SM_CONSTANTS } from "../../../shared/constants/sm-constants";
import { MatDialog } from "@angular/material/dialog";
import { AddNewBookingComponent } from "src/app/shared/components/add-new-booking/add-new-booking.component";
import { ManageBookingComponent } from "src/app/shared/components/manage-booking/manage-booking.component";
import { AssignJobComponent } from "src/app/shared/components/assign-job/assign-job.component";
import { InvoiceComponent } from "src/app/shared/components/invoice/invoice.component";
import { CustomiseBookingComponent } from "src/app/shared/components/customise-booking/customise-booking.component";
import { LoaderServiceService } from "src/app/providers/loader-service.service";
import { BookingDetailsComponent } from "src/app/shared/components/booking-details/booking-details.component";
import { CustomConfirmDialogComponent } from "src/app/shared/components/custom-confirm-dialog/custom-confirm-dialog.component";
import { MessagingService } from "src/app/providers/messaging.service";
import { AngularFireMessaging } from "@angular/fire/messaging";
import { MatSnackBar, MatSnackBarConfig } from "@angular/material/snack-bar";
import { TranslateService } from "@ngx-translate/core";
import { CreateNewBookingComponent } from "src/app/shared/components/create-new-booking/create-new-booking.component";
import { NewJobDoneComponent } from "src/app/shared/components/new-job-done/new-job-done.component";
import { CreateInvoiceComponent } from "src/app/shared/components/create-invoice/create-invoice.component";
import { YoutubeEmbedVideoComponent } from "../../new-v2-pages/new-v2-component/youtube-embed-video/youtube-embed-video.component";
import { NotificationService } from "src/app/services/notification.service";
import { CustomSnackbarComponent } from "src/app/shared/components/custom-snackbar/custom-snackbar.component";
import { AuthService } from "src/app/providers/auth.service";
import { MeetingDataForAppointmentComponent } from "../../new-v2-pages/new-v2-component/meeting-data-for-appointment/meeting-data-for-appointment.component";
import { AddJoiningInterestComponent } from "../../new-v2-pages/new-v2-component/add-joining-interest/add-joining-interest.component";

@Component({
  selector: "sm-bookings",
  templateUrl: "./bookings.component.html",
  styleUrls: ["./bookings.component.scss"],
})
export class BookingsComponent implements OnInit, OnDestroy {
  interestData: any = [];
  tableDisplayColumnsforquery: ITableColumnHeader[] = [
    {
      columnName: "customer name",
      columnProperty: "customer_name",
    },
    {
      columnName: "phone",
      columnProperty: "phone",
    },
    {
      columnName: "service mode",
      columnProperty: "service_mode",
    },
    {
      columnName: "opted services",
      columnProperty: "opted_services",
    },
    {
      columnName: "opted timings",
      columnProperty: "opted_timings",
    },
    // {
    //   columnName: 'customer notes',
    //   columnProperty: "customer_notes",
    // },
    // {
    //   columnName: 'entity reply',
    //   columnProperty: "entity_reply",
    // },
    {
      columnName: "status",
      columnProperty: "item_status",
    },
  ];
  queryData: any = [];
  tableDisplayColumnsforserviceQuery: ITableColumnHeader[] = [
    {
      columnName: "name",
      columnProperty: "name",
    },
    {
      columnName: "phone",
      columnProperty: "phone",
    },
  
    {
      columnName: "service mode",
      columnProperty: "s_mode",
    },
    {
      columnName: "Enquiry type",
      columnProperty: "e_type",
    },
    {
      columnName: "status",
      columnProperty: "item_status",
    },
  ];
  @Output() onButtonClick: EventEmitter<boolean> = new EventEmitter<boolean>();
  entityHashId: string = "";
  bookingType: string = "";
  pageTitle: string = "Bookings";
  @Input() pageSubTitle: string = "";
  @Input() showBackButton: boolean = false;
  @Input("buttonText") showButton: string = "";
  selectedValue: string = "0";
  headerCustomTemplate!: TemplateRef<any>;
  @ViewChild("costTemplate", { static: true })
  costTemplateRef!: TemplateRef<HTMLElement>;
  toDate: any = new Date()
    .toISOString()
    .replace(/T.*/, "")
    .split("-")
    .join("-");
  fromDate: any = "";
  bookingsData: any[] = [];
  public loader: boolean = false;
  public visible: boolean = false;

  tableDisplayColumns: ITableColumnHeader[] = [
    {
      columnName: this.translateService.instant(
        "business_bookings.column_headers.booking_no"
      ),
      columnProperty: "appointment_no",
    },
    {
      columnName: this.translateService.instant(
        "business_bookings.column_headers.customer_name"
      ),
      columnProperty: "cust_name",
    },
    {
      columnName: this.translateService.instant(
        "business_bookings.column_headers.customer_phone"
      ),
      columnProperty: "cust_phn",
    },
    {
      columnName: this.translateService.instant(
        "business_bookings.column_headers.services"
      ),
      columnProperty: "servicesArray",
    },
    {
      columnName: this.translateService.instant(
        "business_bookings.column_headers.cost"
      ),
      columnProperty: "costing",
      columnTemplate: this.costTemplateRef,
    },

    {
      columnName: this.translateService.instant(
        "business_bookings.column_headers.payment_status"
      ),
      columnProperty: "paymentStat",
    },
    {
      columnName: this.translateService.instant(
        "business_bookings.column_headers.start_time"
      ),
      columnProperty: "bookingStartTime",
    },
    {
      columnName: this.translateService.instant(
        "business_bookings.column_headers.end_time"
      ),
      columnProperty: "bookingEndTime",
    },
    {
      columnName: this.translateService.instant(
        "business_bookings.column_headers.assigned_to"
      ),
      columnProperty: "employeeName",
    },
    {
      columnName: this.translateService.instant(
        "business_bookings.column_headers.booking_status"
      ),
      columnProperty: "bookingStat",
    },
  ];
  discountInfo: any = null;
  private _apiSubscription: Subscription;
  constructor(
    private _navService: NavigationService,
    private dialog: MatDialog,
    private router: Router,
    private route: ActivatedRoute,
    private _apiService: ApiService,
    public _modelRef: MatDialog,
    private loaderService: LoaderServiceService,
    private messagingService: MessagingService,
    private angularFireMessaging: AngularFireMessaging,
    private _snackBar: MatSnackBar,
    private translateService: TranslateService,
    private notificationService: NotificationService,
    private authService: AuthService
  ) {
    this.listenForNewBookingUpdates();
    this.listenForBookingStatusUpdates();
    this.listenForBookingAssignmentUpdates();
    this._navService.hideSidebarAndNav = false;

    this._apiSubscription = this._apiService.apiResult.subscribe((resData) => {
      console.log("inBookings1:", resData);
      if (
        resData.responseType === SM_CONSTANTS.RESULT_API_GET_ENTITY_SLOTS_INFO
      ) {
        console.log(resData);
        this.bookingsData = resData.result ? resData.result : [];
        this.bookingsData = this.sortObjectsDescendingByBookingNumber(
          this.bookingsData
        );

        this.bookingsData.forEach((element: any) => {
          if (element.customerInfo) {
            element.customerInfo = JSON.parse(element.customerInfo);
            element.customerName = element.customerInfo.name;
            element.customerPhone = element.customerInfo.phone;
          }

          if (element.serviceInfo) {
            if (element.serviceInfo != null) {
              element.servicesArray = [];
              element.serviceInfo.forEach((item: any) => {
                element.servicesArray.push(" " + item.serviceName);
              });
            }
          }
          if (element.custom_items) {
            if (element.custom_items != null) {
              element.custom_items =
                typeof element.custom_items == "string"
                  ? JSON.parse(element.custom_items)
                  : element.custom_items;
              element.customItemsArray = [];
              element.serviceInfo.forEach((item: any) => {
                element.customItemsArray.push(" " + item.item_name);
              });
            }
          }
          if (element.appointment_products) {
            if (element.appointment_products != null) {
              element.appointment_products =
                typeof element.appointment_products == "string"
                  ? JSON.parse(element.appointment_products)
                  : element.appointment_products;
              // element.customItemsArray = []
              // element.serviceInfo.forEach((item:any) => {
              //   element.customItemsArray.push(' ' + item.item_name)
              // });
            }
          }

          element.costing = element.currency_symbol
            ? element.currency_symbol + element.price
            : "₹" + element.price;

          if (element.customer_name == "null" || !element.customer_name) {
            element.cust_name = "New Customer";
          } else if (element.customer_name != "null" || element.customer_name) {
            element.cust_name = element.customer_name;
          }

          if (element.customer_phone == "null" || !element.customer_phone) {
            element.cust_phn = "N/A";
          } else if (
            element.customer_phone != "null" ||
            element.customer_phone
          ) {
            element.cust_phn =
              element.country_code + " " + element.customer_phone;
          }

          if (element.paymentStatus === 0 || !element.paymentStatus) {
            element.paymentStat = "Due";
          } else if (element.paymentStatus == 1) {
            element.paymentStat = "Done";
          } else if (element.paymentStatus == 2) {
            element.paymentStat = "Payment in progress";
          } else if (element.paymentStatus == 3) {
            element.paymentStat = "Error in payment";
          } else {
            element.paymentStat = "N/A";
          }

          // }

          if (element.bookingStartTime && element.bookingStartTime != null) {
            element.bookingStartTime = element.bookingStartTime.slice(0, 5);
          }
          if (element.bookingEndTime && element.bookingEndTime != null) {
            element.bookingEndTime = element.bookingEndTime.slice(0, 5);
          }

          if (
            element.bookingStatus == 0 ||
            element.bookingStatus == 1 ||
            element.bookingStatus == 2
          ) {
            element.bookingStat = "New booking";
          } else if (element.bookingStatus == 3) {
            element.bookingStat = "Under process";
          } else if (element.bookingStatus == 4) {
            element.bookingStat = "Completed";
          } else if (element.bookingStatus == 5) {
            element.bookingStat = "Booking confirmed";
          } else if (element.bookingStatus == 6) {
            element.bookingStat = "Cancelled by User";
          } else if (element.bookingStatus == 7) {
            element.bookingStat = "Assigned";
          } else if (element.bookingStatus == 8) {
            element.bookingStat = "Cancelled by service provider";
          } else if (element.bookingStatus == 9) {
            element.bookingStat = "Partially Complete";
          }

          if (!element.employeeName) {
            element.employeeName = "N/A";
          }
        });

        this._apiService.getBillDiscountData(
          localStorage.getItem(
            SM_CONSTANTS.CURRENT_ENTITY_PUBLIC_PROFILE_HASH_ID
          )
        );

        console.log(this.bookingsData);
      }
      if (
        resData.responseType ===
        SM_CONSTANTS.RESULT_API_GET_ENROLL_INTEREST_BY_ENTITY_ID
      ) {
        this.interestData = [];
        if (resData.result) {
          this.interestData = resData.result;
          console.log(this.interestData);

          this.interestData.forEach((element: any) => {
            element.request_services =
              typeof element.request_services == "string"
                ? JSON.parse(element.request_services)
                : element.request_services;
            element.custom_items =
              typeof element.custom_items == "string"
                ? JSON.parse(element.custom_items)
                : element.custom_items;
            element.products =
              typeof element.products == "string"
                ? JSON.parse(element.products)
                : element.products;
            element.request_timings =
              typeof element.request_timings == "string"
                ? JSON.parse(element.request_timings)
                : element.request_timings;
            element.phone =
              element.customer_country_code + " " + element.customer_phone;

            if (element.interest_type == 0) {
              element.service_mode = "Home service";
            } else if (element.interest_type == 1) {
              element.service_mode = "In-premise service";
            } else if (element.interest_type == 2) {
              element.service_mode = "Virtual service";
            }

            if (element.enrollment_request_status == 1) {
              element.item_status = "New";
            } else if (element.enrollment_request_status == 2) {
              element.item_status = "In progress";
            } else if (element.enrollment_request_status == 3) {
              element.item_status = "Marked as enrolled";
            } else if (element.enrollment_request_status == 4) {
              element.item_status = "Cancelled";
            } else if (element.enrollment_request_status == 5) {
              element.item_status = "Enrolled";
            }

            element.opted_services = element.request_services
              ? this.getServiceNames(element.request_services)
              : "";
            element.opted_timings = element.request_timings
              ? this.formatSchedule(element.request_timings)
              : "";
          });
        }
        this._apiService.getBillDiscountData(
          localStorage.getItem(
            SM_CONSTANTS.CURRENT_ENTITY_PUBLIC_PROFILE_HASH_ID
          )
        );
      }
      if (
        resData.responseType === SM_CONSTANTS.RESULT_API_GET_ENTITY_ENQUIRY_LIST
      ) {
        this.queryData = [];
        if (resData.result) {
          this.queryData = resData.result;
          console.log(this.queryData);

          this.queryData.forEach((element: any) => {
            element.phone = element?.country_code + " " + element.phone;
            element.email = element.email ?? '' ;

            if (element.service_mode == 0) {
              element.s_mode = "Home service";
            } else if (element.service_mode == 1) {
              element.s_mode = "In-premise service";
            } else if (element.service_mode == 2) {
              element.s_mode = "Virtual service";
            }

            if (element.status == 1) {
              element.item_status = "New";
            } else if (element.status == 2) {
              element.item_status = "In progress";
            } else if (element.status == 3) {
              element.item_status = "Resolved";
            } else {
              element.item_status = "---";
            }

            if (element.enquiry_type == 1) {
              element.e_type = "Booking";
            } else if (element.enquiry_type == 2) {
              element.e_type = "Membership";
            } else if (element.enquiry_type == 3) {
              element.e_type = "Payment";
            } else if (element.enquiry_type == 4) {
              element.e_type = "Feedback";
            } else if (element.enquiry_type == 5) {
              element.e_type = "Others";
            }
          });
        }
        this._apiService.getBillDiscountData(
          localStorage.getItem(
            SM_CONSTANTS.CURRENT_ENTITY_PUBLIC_PROFILE_HASH_ID
          )
        );
      }
      if (
        resData.responseType === SM_CONSTANTS.RESULT_API_GET_ENTITY_DISCOUNT
      ) {
        this.discountInfo = null;
        if (resData.result) {
          this.discountInfo = resData.result;
        }
        this.loaderService.showLoader = false;
        this.visible = true;
      }
      if (
        resData.responseType === SM_CONSTANTS.RESULT_API_UPDATE_BOOKING_STATUS
      ) {
        this._apiService.getEntitySlotsInfo(
          this.entityHashId,
          this.bookingType,
          this.selectedValue
        );
      }
      if (
        resData.responseType ===
        SM_CONSTANTS.RESULT_API_UPDATE_BOOKING_STATUS_WITH_INVOICE
      ) {
        this._apiService.getEntitySlotsInfo(
          this.entityHashId,
          this.bookingType,
          this.selectedValue
        );
        // alert("Invoice generated")
      }
      if (
        resData.responseType === SM_CONSTANTS.RESULT_API_RESET_BOOKING_DETAILS
      ) {
        this._apiService.getEntitySlotsInfo(
          this.entityHashId,
          this.bookingType,
          this.selectedValue
        );
      }
      if (
        resData.responseType ===
        SM_CONSTANTS.RESULT_API_CUSTOMISE_BOOKING_DETAILS
      ) {
        this._apiService.getEntitySlotsInfo(
          this.entityHashId,
          this.bookingType,
          this.selectedValue
        );
      }
      if (
        resData.responseType === SM_CONSTANTS.RESULT_API_ADD_EDIT_PAYMENT_RECORD
      ) {
        this._apiService.getEntitySlotsInfo(
          this.entityHashId,
          this.bookingType,
          this.selectedValue
        );
      }
      if (
        resData.responseType ===
        SM_CONSTANTS.RESULT_API_ADD_EDIT_INTERNATIONAL_INVOICE_PAYMENT_RECORD
      ) {
        this._apiService.getEntitySlotsInfo(
          this.entityHashId,
          this.bookingType,
          this.selectedValue
        );
      }
      if (
        resData.responseType ===
        SM_CONSTANTS.RESULT_API_DELETE_ENTITY_APPOINTMENT_DATA
      ) {
        this._apiService.getEntitySlotsInfo(
          this.entityHashId,
          this.bookingType,
          this.selectedValue
        );
      }
      if (
        resData.responseType === SM_CONSTANTS.RESULT_API_DELETE_ENTITY_INVOICE
      ) {
        this._apiService.getEntitySlotsInfo(
          this.entityHashId,
          this.bookingType,
          this.selectedValue
        );
      }
      if (
        resData.responseType ===
        SM_CONSTANTS.RESULT_API_DELETE_INTERNATIONAL_INVOICE_DETAILS
      ) {
        if (resData.result) {
          this._apiService.getEntitySlotsInfo(
            this.entityHashId,
            this.bookingType,
            this.selectedValue
          );
        }
      }

      this.loader = false;
      // this.visible = true
    });

    this.translateService.onLangChange.subscribe(() => {
      // Update your column headers when the language changes
      this.updateColumnHeaders();
    });
  }
  private updateColumnHeaders() {
    this.tableDisplayColumns.forEach((column, index) => {
      let data = [
        "booking_no",
        "customer_name",
        "customer_phone",
        "services",
        "cost",
        "payment_status",
        "start_time",
        "end_time",
        "assigned_to",
        "booking_status",
      ];
      // Update each column header with the translated value
      column.columnName = this.translateService.instant(
        `business_bookings.column_headers.${data[index]}`
      );
    });
  }
  eph: string = "";
  isOwner: boolean = false;
  ngOnInit(): void {
    this.isOwner = this.authService.isOwner();
    console.log("owner", this.isOwner);

    // this.loader = true
    this.route.queryParams.subscribe((data) => {
      console.log(data.entityHash);
      this.entityHashId = data.entityHash;
      this.eph = data.eph;
      this.bookingType = data.bookingType;
    });
    // this.loader = true
    this.visible = false;
    this.loaderService.showLoader = true;
    this._apiService.getEntitySlotsInfo(
      this.entityHashId,
      this.bookingType,
      this.selectedValue
    );
  }
  ngOnDestroy(): void {
    this._apiSubscription.unsubscribe();
    if (this.newbookingsubscription) {
      this.newbookingsubscription.unsubscribe();
    }
    if (this.bookingStatusUpdatedsubscription) {
      this.bookingStatusUpdatedsubscription.unsubscribe();
    }
    if (this.bookingAssignmentsubscription) {
      this.bookingAssignmentsubscription.unsubscribe();
    }
    // this.translateService.onLangChange.unsubscribe();
  }

  openSnackBar(message: string, action?: string) {
    let config = new MatSnackBarConfig();
    config.panelClass = ["custom-class"];
    config.verticalPosition = "top";
    config.horizontalPosition = "center";
    config.duration = 3000;
    this._snackBar.open(message, action, config);
  }

  refreshScreen() {
    this.loaderService.showLoader = true;
    if (this.selectedValue == "0" || this.selectedValue == "1") {
      this._apiService.getEntitySlotsInfo(
        this.entityHashId,
        this.bookingType,
        this.selectedValue
      );
    } else if (this.selectedValue == "2") {
      this.fromDate = new Date();
      this.toDate = new Date();
      this.fromDate.setDate(this.fromDate.getDate() - 90);
      this._apiService.getAllEnrollInterestByEntityId(
        this.entityHashId,
        "1",
        this.formatDate1(this.fromDate),
        this.formatDate1(this.toDate),
        this.pageNo.toString(),
        this.bookingType
      );
    } else if (this.selectedValue == "3") {
      this.fromDate = new Date();
      this.toDate = new Date();
      this.fromDate.setDate(this.fromDate.getDate() - 90);
      this._apiService.getEntityEnquiryList(
        this.entityHashId,
        this.formatDate1(this.fromDate),
        this.formatDate1(this.toDate),
        this.bookingType
      );
    }
    // this._apiService.getEntitySlotsInfo(
    //   this.entityHashId,
    //   this.bookingType,
    //   this.selectedValue
    // );
  }

  navigate() {
    this.router.navigate(["../"], {
      relativeTo: this.route,
      queryParamsHandling: "preserve",
    });
  }
  search() {
    console.log(this.fromDate);
    console.log(this.toDate);
    this._apiService.getBookingsList(
      this.entityHashId,
      this.fromDate,
      this.toDate
    );
    this.visible = false;
    // this.loader = true
  }

  // pagination check for queries list
  pageNo: number = 1;
  changeChip(value: string) {
    this.selectedValue = value;
    // this.loader = true
    this.visible = false;
    this.loaderService.showLoader = true;
    if (this.selectedValue == "0" || this.selectedValue == "1") {
      this._apiService.getEntitySlotsInfo(
        this.entityHashId,
        this.bookingType,
        this.selectedValue
      );
    } else if (this.selectedValue == "2") {
      this.fromDate = new Date();
      this.toDate = new Date();
      this.fromDate.setDate(this.fromDate.getDate() - 90);
      this._apiService.getAllEnrollInterestByEntityId(
        this.entityHashId,
        "1",
        this.formatDate1(this.fromDate),
        this.formatDate1(this.toDate),
        this.pageNo.toString(),
        this.bookingType
      );
    } else if (this.selectedValue == "3") {
      this.fromDate = new Date();
      this.toDate = new Date();
      this.fromDate.setDate(this.fromDate.getDate() - 90);
      this._apiService.getEntityEnquiryList(
        this.entityHashId,
        this.formatDate1(this.fromDate),
        this.formatDate1(this.toDate),
        this.bookingType
      );
    }
  }

  formatDate1(dateStr: Date) {
    let curdate = new Date(dateStr)
      .toLocaleString("en-CA", {
        timeZone: "Asia/Kolkata",
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
      })
      .slice(0, 10);

    return curdate;
  }

  createInvoice() {
    let data = {
      entityHash: this.entityHashId,
      serviceType: this.bookingType,
      discountInfo: this.discountInfo,
    };
    // this._modelRef.open(AddNewBookingComponent, {
    //   width: '700px',
    //   data: {
    //     title: 'New Booking',
    //     ref: this._modelRef,
    //     data: data
    //   },
    // });
    this._modelRef.open(CreateInvoiceComponent, {
      width: "700px",
      data: {
        title: "New Invoice",
        ref: this._modelRef,
        data: data,
      },
    });
  }

  createNewBooking() {
    let data = {
      entityHash: this.entityHashId,
      eph: this.eph,
      serviceType: this.bookingType,
      discountInfo: this.discountInfo,
      isForTomorrow: this.selectedValue,
    };

    let dialogref = this._modelRef.open(CreateNewBookingComponent, {
      width: "750px",
      data: {
        title: "New Booking",
        ref: this._modelRef,
        data: data,
      },
    });
    dialogref.afterClosed().subscribe((res) => {
      if (res) {
        if (res.selectedBookingType == 4) {
          this.visible = false;
          this.changeChip("1");
        } else if (res.selectedBookingType == 5) {
          const dialogRef = this._modelRef.open(CustomConfirmDialogComponent, {
            width: "500px",
            data: {
              title: "Booking done!",
              message:
                "A new booking created successfully in " +
                localStorage.getItem(SM_CONSTANTS.CURRENT_ENTITY_NAME) +
                " at " +
                this.convertTime24to12(
                  res.bookingData.bookingStatusInfo.startTime
                ) +
                " - " +
                this.convertTime24to12(
                  res.bookingData.bookingStatusInfo.endTime
                ) +
                "  slot on " +
                this.formatDate(
                  res.bookingData.bookingStatusInfo.bookingDate.split(" ")[0]
                ) +
                ".",
              cancelbtn: "Continue",
              okbtn: "See the list",
              type: SM_CONSTANTS.CUSTOM_DIALOG_CONFIRM_TYPE,
            },
            disableClose: true,
          });
          dialogRef.afterClosed().subscribe((result) => {
            console.log(result);
            if (result) {
              this.router.navigate(["/businesses/details/booking-history"], {
                queryParams: { entityHash: this.entityHashId },
              });
            }
          });
        } else {
          this.visible = false;
          this.changeChip("0");
        }
      }
    });
  }
  openJobDone() {
    let data = {
      entityHash: this.entityHashId,
      serviceType: this.bookingType,
    };
    // this._modelRef.open(AddNewBookingComponent, {
    //   width: '700px',
    //   data: {
    //     title: 'New Booking',
    //     ref: this._modelRef,
    //     data: data
    //   },
    // });
    this._modelRef.open(NewJobDoneComponent, {
      width: "700px",
      data: {
        title: "Manage booking",
        ref: this._modelRef,
        data: data,
      },
    });
  }

  startProcess(item: any) {
    let data = {
      bookingStatusInfo: {
        assignedToHash: localStorage.getItem(
          SM_CONSTANTS.OWNER_EMPLOYEE_HASH_ID
        ),
        assignedByHash: localStorage.getItem(
          SM_CONSTANTS.OWNER_EMPLOYEE_HASH_ID
        ),
        appointmentHash: item.hash_id,
        bookingStatus: 3,
        startTime: this.formatTime(new Date()),
        endTime: this.addOneHour(this.formatTime(new Date())),
        entityHash: item.entityHash,
        countryCode: item.country_code,
        customerPh: item.customer_phone,
        customerName: item.customer_name,
        price: item.price,
        bookingDate: item.bookingDate,
        note: item.note,
        bookingType: item.bookingType,
        customerHash: item.customerInfo.hash_id,
      },
    };

    console.log(data);
    this.loaderService.showLoader = true;
    this._apiService.updateBookingStatus(data);
  }

  addOneHour(timeStr: any) {
    const [hours, minutes] = timeStr.split(":").map(Number);
    const date = new Date();
    date.setHours(hours);
    date.setMinutes(minutes);
    date.setSeconds(0);

    // Add one hour
    date.setHours(date.getHours() + 1);

    // Format back to HH:mm
    const newHours = String(date.getHours()).padStart(2, "0");
    const newMinutes = String(date.getMinutes()).padStart(2, "0");

    return `${newHours}:${newMinutes}`;
  }
  confirmBooking(item: any) {
    let data = {
      bookingStatusInfo: {
        assignedToHash: localStorage.getItem(
          SM_CONSTANTS.OWNER_EMPLOYEE_HASH_ID
        ),
        assignedByHash: localStorage.getItem(
          SM_CONSTANTS.OWNER_EMPLOYEE_HASH_ID
        ),
        appointmentHash: item.hash_id,
        bookingStatus: 5,
        startTime: item.bookingStartTime.slice(0, 5),
        endTime: item.bookingEndTime.slice(0, 5),
        entityHash: item.entityHash,
        countryCode: item.country_code,
        customerPh: item.customer_phone,
        customerName: item.customer_name,
        price: item.price,
        bookingDate: this.formatDateString(new Date(item.bookingDate)),
        note: item.note,
        bookingType: item.bookingType,
        customerHash: item.customerInfo.hash_id,
      },
    };

    console.log(data);
    this.loaderService.showLoader = true;
    this._apiService.updateBookingStatus(data);
  }

  formatDateString(inputDateString: Date): string {
    const inputDate = new Date(inputDateString);
    const year = inputDate.getFullYear();
    const month = (inputDate.getMonth() + 1).toString().padStart(2, "0"); // Month is 0-indexed
    const day = inputDate.getDate().toString().padStart(2, "0");
    const hours = inputDate.getHours().toString().padStart(2, "0");
    const minutes = inputDate.getMinutes().toString().padStart(2, "0");
    const seconds = inputDate.getSeconds().toString().padStart(2, "0");

    return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
  }
  cancelBooking(item: any) {
    // if(confirm("Are you sure you want to cancel this booking?")){

    // let data = {
    //   bookingStatusInfo: {
    //     appointmentHash: item.hash_id,
    //     bookingStatus: 8,
    //   }
    // }

    // console.log(data);
    // this.loaderService.showLoader = true
    // this._apiService.updateBookingStatus(data)
    // }

    const dialogRef = this._modelRef.open(CustomConfirmDialogComponent, {
      data: {
        title: "Alert",
        message: "Are you sure you want to cancel this booking?",
        okbtn: "Yes",
        cancelbtn: "No",
        type: SM_CONSTANTS.CUSTOM_DIALOG_CONFIRM_TYPE,
      },
      disableClose: true,
    });
    dialogRef.afterClosed().subscribe((result) => {
      console.log(result);
      if (result) {
        let notedialogref = this.dialog.open(CancelBookingNotesModalComponent, {
          width: "600px",
          data: {
            title: "Cancel Booking",
          },
        });
        notedialogref.afterClosed().subscribe((res) => {
          if (res) {
            let data = {
              bookingStatusInfo: {
                bookingStatus: 8,
                assignedToHash: localStorage.getItem(
                  SM_CONSTANTS.OWNER_EMPLOYEE_HASH_ID
                ),
                assignedByHash: localStorage.getItem(
                  SM_CONSTANTS.OWNER_EMPLOYEE_HASH_ID
                ),
                appointmentHash: item.hash_id,
                startTime: item.bookingStartTime.slice(0, 5),
                endTime: item.bookingEndTime.slice(0, 5),
                entityHash: item.entityHash,
                countryCode: item.country_code,
                customerPh: item.customer_phone,
                customerName: item.customer_name,
                price: item.price,
                bookingDate: item.bookingDate,
                note: item.note,
                cancellationNotes: res.notes,
                bookingType: item.bookingType,
                customerHash: item.customerInfo.hash_id,
              },
            };

            console.log(data);
            this.loaderService.showLoader = true;
            this._apiService.updateBookingStatus(data);
          }
        });
      }
    });
  }

  done(item: any) {
    let data = {
      entityHash: this.entityHashId,
      eph: this.eph,
      serviceType: this.bookingType,
      bookingData: item,
      discountInfo: this.discountInfo,
    };
    this._modelRef.open(ManageBookingComponent, {
      width: "700px",
      data: {
        title: "Manage Booking",
        ref: this._modelRef,
        data: data,
      },
    });
  }

  assignJob(item: any) {
    this._modelRef.open(AssignJobComponent, {
      width: "800px",
      data: {
        title: "Assign job",
        ref: this._modelRef,
        data: item,
      },
    });
  }

  reset(item: any) {
    // if(confirm("This will remove all the operation data like booked services, completed services status, employee engagement, etc. The appointment status will become NEW once again. Are you sure you want to continue?")){
    //   let data =  {
    //     appointmentHashId: item.hash_id
    //   }
    //   this.loaderService.showLoader = true
    //   this._apiService.resetBookingDetails(data)
    // }

    const dialogRef = this._modelRef.open(CustomConfirmDialogComponent, {
      maxWidth: "700px",
      data: {
        title: "Alert",
        message:
          "This will remove all the operation data like booked services, completed services status, employee engagement, etc. The appointment status will become NEW once again. Are you sure you want to continue?",
        okbtn: "Yes",
        cancelbtn: "No",
        type: SM_CONSTANTS.CUSTOM_DIALOG_CONFIRM_TYPE,
      },
      disableClose: true,
    });
    dialogRef.afterClosed().subscribe((result) => {
      console.log(result);
      if (result) {
        let data = {
          appointmentHashId: item.hash_id,
        };
        this.loaderService.showLoader = true;
        this._apiService.resetBookingDetails(data);
      }
    });
  }

  openInvoice(item: any) {
    this._modelRef.open(InvoiceComponent, {
      width: "510px",
      data: {
        title: "Invoice",
        ref: this._modelRef,
        showmerge: 1,
        data: item.hash_id,
      },
    });
  }
  bookingDetails(item: any) {
    // this._modelRef.open(BookingDetailsComponent, {
    //   width: "700px",
    //   data: {
    //     title: "Bookings Details",
    //     ref: this._modelRef,
    //     data: item,
    //   },
    // });
    this.router.navigate(["booking-details"], {
      relativeTo: this.route,
      queryParamsHandling: "merge",
      queryParams: { bookingHash: item.hash_id, merge: "1" },
    });
  }

  customiseBooking(item: any) {
    this.loaderService.showLoader = true;
    let data = {
      entityHash: this.entityHashId,
      eph: this.eph,
      serviceType: this.bookingType,
      bookingData: item,
      discountInfo: this.discountInfo,
    };
    this._modelRef.open(CustomiseBookingComponent, {
      width: "700px",
      data: {
        title: "Edit Booking Operation",
        ref: this._modelRef,
        data: data,
      },
    });
  }

  sortObjectsDescendingByBookingNumber(array: any) {
    return array
      .slice()
      .sort(
        (a: any, b: any) =>
          parseInt(b.appointment_no) - parseInt(a.appointment_no)
      );
  }

  formatTime(date: Date): string {
    const hours = date.getHours().toString().padStart(2, "0"); // Ensure two digits, pad with leading zero if necessary
    const minutes = date.getMinutes().toString().padStart(2, "0"); // Same for minutes
    return `${hours}:${minutes}`;
  }

  createNotification(title: any, text: any) {
    const noti = new Notification(title, {
      body: text,
    });
  }

  deleteBooking(item: any) {
    const dialogRef = this._modelRef.open(CustomConfirmDialogComponent, {
      data: {
        title: "Alert",
        message: "Are you sure you want to delete this booking?",
        okbtn: "Yes",
        cancelbtn: "No",
        type: SM_CONSTANTS.CUSTOM_DIALOG_CONFIRM_TYPE,
      },
      disableClose: true,
    });
    dialogRef.afterClosed().subscribe((result) => {
      console.log(result);
      if (result) {
        let obj = {
          appointmentHash: item.hash_id,
          entityHash: this.entityHashId,
        };

        this.loaderService.showLoader = true;
        this._apiService.deleteEntityAppointmentData(obj);
      }
    });
  }

  openvideo() {
    this.dialog.open(YoutubeEmbedVideoComponent, {
      width: "1000px",
      disableClose: true,
      data: {
        link: "https://www.youtube.com/embed/lXkWk_I6L_w?si=J4BhAhR4MFNaaqJE",
        title: "Creating Bookings/Appointments in LookzUp Business Portal. ",
      },
    });
  }

  opencontact() {
    this.router.navigate(["/contact-us"]);
  }

  convertTime24to12(time: any) {
    // Split the time into hours and minutes
    let [hours, minutes] = time.split(":").map(Number);

    // Determine AM or PM
    const period = hours >= 12 ? "PM" : "AM";

    // Convert hours from 24-hour to 12-hour format
    hours = hours % 12 || 12; // Converts 0 to 12 for midnight and 12-hour format

    // Format hours and minutes to always be two digits
    const formattedTime = `${hours.toString().padStart(2, "0")}:${minutes
      .toString()
      .padStart(2, "0")} ${period}`;

    return formattedTime;
  }

  formatDate(dateTime: any) {
    // Create a new Date object from the input string
    console.log(dateTime);

    const date = new Date(dateTime);

    // Define arrays for month names
    const monthNames = [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December",
    ];

    // Get day, month, and year from the Date object
    const day = date.getDate();
    const month = monthNames[date.getMonth()];
    const year = date.getFullYear();

    // Return the formatted date
    return `${day} ${month} ${year}`;
  }

  private newbookingsubscription: Subscription = new Subscription();
  listenForNewBookingUpdates() {
    this.newbookingsubscription = this.notificationService
      .getNotificationByType("newBooking")
      .subscribe((payload) => {
        if (true) {
          console.log("New notification received:", payload);
          // payload.data.misc = typeof payload.data.misc == 'string' ? JSON.parse(payload.data.misc) : payload.data.misc
          if (
            payload.data.misc.entityHash == this.entityHashId ||
            payload.data.misc.entityHash == this.eph
          ) {
            const title = payload.data.title;
            const message = payload.data.message;
            const onRefresh = () => {
              this.loaderService.showLoader = true;
              this._apiService.getEntitySlotsInfo(
                this.entityHashId,
                this.bookingType,
                this.selectedValue
              );
            };
            const snackBarRef = this._snackBar.openFromComponent(
              CustomSnackbarComponent,
              {
                duration: 5000, // Adjust duration as needed
                horizontalPosition: "center",
                verticalPosition: "top",
                data: { title, message, onRefresh },
                panelClass: "custom-class1",
              }
            );
          }
        }
      });
  }
  private bookingAssignmentsubscription: Subscription = new Subscription();
  listenForBookingAssignmentUpdates() {
    this.bookingAssignmentsubscription = this.notificationService
      .getNotificationByType("onCustomerAssign")
      .subscribe((payload) => {
        if (true) {
          console.log("New notification received:", payload);
          // payload.data.misc = typeof payload.data.misc == 'string' ? JSON.parse(payload.data.misc) : payload.data.misc
          if (
            payload.data.misc.entityHash == this.entityHashId ||
            payload.data.misc.entityHash == this.eph
          ) {
            const title = payload.data.title;
            const message = payload.data.message;
            const onRefresh = () => {
              this.loaderService.showLoader = true;
              this._apiService.getEntitySlotsInfo(
                this.entityHashId,
                this.bookingType,
                this.selectedValue
              );
            };
            const snackBarRef = this._snackBar.openFromComponent(
              CustomSnackbarComponent,
              {
                duration: 5000, // Adjust duration as needed
                horizontalPosition: "center",
                verticalPosition: "top",
                data: { title, message, onRefresh },
                panelClass: "custom-class1",
              }
            );
          }
        }
      });
  }

  private bookingStatusUpdatedsubscription: Subscription = new Subscription();
  listenForBookingStatusUpdates() {
    this.bookingStatusUpdatedsubscription = this.notificationService
      .getNotificationByType("bookingStatusUpdated")
      .subscribe((payload) => {
        if (true) {
          console.log("New notification received:", payload);
          // payload.data.misc = typeof payload.data.misc == 'string' ? JSON.parse(payload.data.misc) : payload.data.misc
          if (
            payload.data.misc.entityHash == this.entityHashId ||
            payload.data.misc.entityHash == this.eph
          ) {
            const title = payload.data.title;
            const message = payload.data.message;
            const onRefresh = () => {
              this.loaderService.showLoader = true;
              this._apiService.getEntitySlotsInfo(
                this.entityHashId,
                this.bookingType,
                this.selectedValue
              );
            };
            const snackBarRef = this._snackBar.openFromComponent(
              CustomSnackbarComponent,
              {
                duration: 5000, // Adjust duration as needed
                horizontalPosition: "center",
                verticalPosition: "top",
                data: { title, message, onRefresh },
                panelClass: "custom-class1",
              }
            );
          }
        }
      });
  }
  openLink(url: string): void {
    window.open(url, "_blank");
  }

  addEditMeetingData(item: any) {
    let dialogref = this.dialog.open(MeetingDataForAppointmentComponent, {
      width: "500px",
      data: {
        data: item,
      },
    });
    dialogref.afterClosed().subscribe((data) => {
      if (data) {
        this._apiService.getEntitySlotsInfo(
          this.entityHashId,
          this.bookingType,
          this.selectedValue
        );
      }
    });
  }

  // NEW CODE FOR ROW CLICK
  rowClickHandler = (row: any) => {
    this.bookingDetails(row);
  };

  getServiceNames(services: any) {
    console.log(services);

    return services.map((service: any) => service.service_name).join(", ");
  }

  formatTime1(time: string): string {
    const [hour, minute] = time.split(":").map(Number);
    const period = hour >= 12 ? "PM" : "AM";
    const adjustedHour = hour % 12 || 12; // Convert 0 or 12 to 12 for AM/PM time
    return `${adjustedHour}:${minute.toString().padStart(2, "0")} ${period}`;
  }

  formatTimeForBooking(date: Date): string {
    const hours = date.getHours().toString().padStart(2, "0"); // Ensure two digits, pad with leading zero if necessary
    const minutes = date.getMinutes().toString().padStart(2, "0"); // Same for minutes
    return `${hours}:${minutes}`;
  }

  getWeekdayString(weekday: number): string {
    const weekdays = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
    return weekdays[weekday - 1]; // Adjusting because weekday starts from 1
  }

  formatSchedule(schedule: any[]): string {
    return schedule
      .map((item) => {
        const weekday = this.getWeekdayString(item.weekday);
        const startTime = this.formatTime1(item.start_time);
        const endTime = this.formatTime1(item.end_time);
        return `${weekday}: ${startTime} - ${endTime}`;
      })
      .join(", ");
  }

  rowClickHandlerforquery = (row: any) => {
    this.viewDetails(row);
  };

  viewDetails(item: any) {
    // this.loaderservice.showLoader = true
    // this.dialog.open(JoiningInterestDetailsComponent,{
    //   width:'600px',
    //   disableClose:true,
    //   data: {
    //     data: item
    //   }
    // })
    this.router.navigate(["query-details"], {
      relativeTo: this.route,
      queryParamsHandling: "merge",
      queryParams: { queryHash: item.hash_id, serviceType: this.bookingType },
    });
  }
  rowClickHandlerforservicequery = (row: any) => {
    this.viewDetailsforservicequery(row);
  };

  viewDetailsforservicequery(item: any) {
    // this.loaderservice.showLoader = true
    // this.dialog.open(JoiningInterestDetailsComponent,{
    //   width:'600px',
    //   disableClose:true,
    //   data: {
    //     data: item
    //   }
    // })
    this.router.navigate(["service-query-details"], {
      relativeTo: this.route,
      queryParamsHandling: "merge",
      queryParams: { queryHash: item.hash_id, serviceType: this.bookingType },
    });
  }



    addNewInterest(){
      
      let data = {
        entityHash: this.entityHashId,
        eph: this.eph,
        serviceType: this.bookingType,
      }
  
      let dialogref = this.dialog.open(AddJoiningInterestComponent, {
        width: '750px',
        data: {
          title: 'New query',
          ref: this.dialog,
          data: data
        },
      });
      dialogref.afterClosed().subscribe(res => {
        if(res){
          this.changeChip('2')
        }
      })
    }
}
